module.exports = __webpack_public_path__ + "img/13.691ae55d.png";